export default function Contact() {
    return <div className='body-text'>More to come soon!</div>
}